import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import NavbarComponent from './components/Navbar';
import CrudPrompt from './components/prompts/CRUDPrompt';
import TestPrompt from './components/prompts/TestPrompt';
import Logs from './components/prompts/Logs';
import Log from './components/prompts/Log';
import NewPrompt from './components/prompts/NewPrompt';
import { ThemeProvider } from './components/ThemeProvider';
import NotFoundPage from './components/NotFoundPage';
import ExpandableSidebar from './components/ExpandableSidebar';
import EnvironmentsPage from './components/settings/EnvironmentsPage';
import ApiTokensPage from './components/settings/ApiTokensPage';
import PromptsTable from './components/prompts/PromptsTable';
import SecretsManager from './components/settings/SecretsManager';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SettingsPage from './components/settings/SettingsPage';
import OrganizationsPage from './components/settings/OrganizationsPage';
import OrganizationPage from './components/settings/OrganizationPage';
import InvitationsPage from './components/settings/InvitationsPage';
import PromptTests from './components/prompts/PromptTests';
import TestsTable from './components/prompts/TestsTable';
import TestResults from './components/prompts/TestResults';
import VersionTestResult from './components/prompts/VersionTestResult';
import CRUDTest from './components/prompts/CRUDTest';
import VersionImprovements from './components/prompts/VersionImprovements';
import CreateTest from './components/prompts/CreateTest';
import GettingStarted from './components/future/GettingStarted';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className='relative min-h-screen bg-white'>
          {/* Sidebar with fixed positioning and a high z-index */}
          <div className='fixed inset-y-0 left-0 z-50 bg-gray-200'>
            <ExpandableSidebar />
          </div>
          {/* Main content */}
          <div className='App pl-16 md:pl-16'>
            <header className='App-header bg-gray-400 z-40'>
              <NavbarComponent />
            </header>
            <Routes>
              <Route path='/' element={<Navigate to='/prompts' />} />
              <Route path='/settings/envs' element={<EnvironmentsPage />} />
              <Route path='/settings/api_tokens' element={<ApiTokensPage />} />
              <Route path='/login' element={<LoginPage />} />
              <Route path='/prompt/new' element={<NewPrompt />} />
              <Route path='/prompt/new/' element={<NewPrompt />} />
              <Route path='/prompts' element={<PromptsTable page='prompts' />} />
              <Route path='/start' element={<GettingStarted />} />
              <Route path='/logs' element={<Logs />} />
              <Route path='/logs/log' element={<Log />} />
              <Route path='/prompts/:prompt_id/' element={<CrudPrompt />} />
              <Route path='/playground' element={<PromptsTable page='playground' />} />
              <Route path='/playground/:prompt_id/' element={<TestPrompt />} />
              <Route path='/tests' element={<TestsTable />} />
              <Route path='/tests/:prompt_id' element={<PromptTests />} />
              <Route path='/tests/:prompt_id/new' element={<CreateTest />} />
              <Route path='/tests/:prompt_id/:test_id' element={<TestResults />} />
              <Route path='/tests/edit/:prompt_id/:test_id' element={<CRUDTest />} />
              <Route path='/tests/improved/:prompt_id/:prompt_version' element={<VersionImprovements />} />
              <Route path='/tests/:prompt_id/:test_id/:prompt_version/:timestamp' element={<VersionTestResult />} />
              {/* add path for behaviors and secrets manager of behaviors */}
              <Route path='/settings/provider_secrets' element={<SecretsManager />} />
              {/* <Route path="/team" element={<TeamPage />} /> */}
              <Route path='/settings' element={<SettingsPage />} />
              <Route path='/settings/organizations' element={<OrganizationsPage />} />
              <Route path='/organization/:org_id' element={<OrganizationPage />} />
              <Route path='/settings/organizations/invitations/:org_id' element={<InvitationsPage />} />
              <Route path='*' element={<NotFoundPage />} /> {/* 404 route */}
            </Routes>
          </div>
        </div>
      </Router>
      <ToastContainer className='text-2xl' />
    </ThemeProvider>
  );
}

export default App;
